// global
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// routes
import { Link } from 'react-router-dom';
// components
import { Popup } from 'semantic-ui-react';
//consts
import { COLORS } from 'app/config/colors';
// stylesheet
import styles from './BreadCrumb.module.scss';
// icons
import ArrowIcon from 'assets/icon/arrow-icon/ArrowIcon';
import CrumbIcon from 'assets/icon/crumb-icon/CrumbIcon';
import CheckIcon from 'assets/icon/check-icon/CheckIcon';
// utils
import { capitalize } from 'app/utils';

function BreadCrumb(props) {
  const { /* id, loading, */ paths, multiline } = props;

  const [folderActive, setFolrderActive] = useState(false);

  const colors = {
    '--bgcolor': COLORS.WHITE_VARIANT,
    '--iconcolor': COLORS.PRIMARY_VARIANT
  };

  const classNameHeader = () => {
    let className = styles.breadCrumb;

    if (multiline) className += ` ${styles.multiline}`;

    return className;
  };

  const AvoidOverflow = () => {
    return (
      <>
        <Popup
          on={'click'}
          hoverable
          position='bottom left'
          pinned
          basic
          onOpen={() => setFolrderActive(true)}
          onClose={() => setFolrderActive(false)}
          style={{ borderRadius: '12px', padding: 0 }}
          trigger={
            <div className={`${styles.folder} ${folderActive ? styles.folderActive : ''}`}>
              <CrumbIcon />
            </div>
          }
          content={
            <ul className={styles.popupList}>
              {paths.map(({ text, to }, index) => {
                const linked = !!to;

                const isLast = paths.length - 1 === index;
                return (
                  <li key={`${text}-${index}`} className={linked && !isLast ? styles.linked : ''}>
                    {isLast || !linked ? (
                      <>
                        {capitalize(text)} {isLast && <CheckIcon size='14' />}
                      </>
                    ) : (
                      <Link to={to}>
                        {capitalize(text)} {isLast && <CheckIcon size='14' />}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          }
        />

        <ArrowIcon direction='right' fill='#202124' size='10' />
      </>
    );
  };

  const quantityPaths = paths.length;
  const isBust = quantityPaths >= 5;

  return (
    <header style={colors} className={classNameHeader()}>
      {isBust && AvoidOverflow()}
      {paths.map(({ text, to }, index) => {
        const linked = !!to;

        if (isBust && quantityPaths - 1 !== index && quantityPaths - 2 !== index) return null;

        const isLast = paths.length - 1 === index;

        const handleClassName = (isLast, linked) => {
          let className = styles.crumbText;

          if (isLast) {
            className += ` ${styles.lastPath}`;
          }

          if (linked) {
            className += ` ${styles.linked}`;
          }

          return className;
        };

        const showArrow = () => {
          if (!multiline) return !isLast;

          if (multiline) return !isLast && paths.length - 2 !== index;
        };

        return (
          <div key={`${text}-${index}`}>
            {isLast || !linked ? (
              <div className={handleClassName(isLast, false)}>{capitalize(text)}</div>
            ) : (
              <Link to={to}>
                <div className={handleClassName(isLast, linked)}>{capitalize(text)}</div>
              </Link>
            )}

            {showArrow() && <ArrowIcon direction='right' fill='#202124' size='10' />}
          </div>
        );
      })}
    </header>
  );
}

BreadCrumb.defaultProps = {
  multiline: false,
  paths: []
};

BreadCrumb.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string,
  paths: PropTypes.arrayOf(PropTypes.shape({ to: PropTypes.string, text: PropTypes.string })),
  onClick: PropTypes.func,
  multiline: PropTypes.bool
};

export default BreadCrumb;
